
import { Avatar, Button, IconButton, Input } from "@mui/material";
import classes from "./Chat.module.css";
import { AttachFile, Camera, Image, People, Search, Send, Settings, ThumbUp } from "@mui/icons-material";
import { Chat as ChatIcon } from "@mui/icons-material";
export const Chat = ({ navigate, params = {} }) => {
  console.log("Chat")
    return (
      <div style={{ display: "flex", height: "100%" }}>
        <div className={classes.menu}>
          <div className={classes.menuTop}>
            <IconButton>
              <ChatIcon></ChatIcon>
            </IconButton>
          </div>
          <div className={classes.menuMid}></div>
          <div className={classes.menuBot}>
            <IconButton>
              <Settings></Settings>
            </IconButton>
          </div>
        </div>
        <div className={classes.groupPanel}>
          <div className={classes.groupFilter}>
            <div className={classes.groupFilterSearch}>
              <Search></Search>
            </div>
            <div className={classes.groupFilterOther}>
              <div>Tất cả</div>
              <div>Chưa đọc</div>
              <div style={{flexGrow:1}}></div>
              <div>Phân loại</div>
            </div>
          </div>
          <div className={classes.groupItem}>
            <Avatar></Avatar>
            <div>
              <div className={classes.groupName}>GroupName</div>
              <div>groupStatus</div>
            </div>
          </div>
        </div>
        <div className={classes.chatPanel}>
          <div className={classes.chatPanelTop}>
            <div style={{height:62,borderBottom: "solid 1px gray"}} className={classes.chatPanelTopRow}>
              <div style={{display:"flex"}}>
                <Avatar></Avatar>
                <div>
                  <div>Group Name</div>
                  <div>Group info</div>
                </div>
              </div>
              <div style={{flexGrow:1}}></div>
              <div>
                <People></People>
                <Search></Search>
                <Camera></Camera>
              </div>
            </div>
            <div style={{height:48}}  className={classes.chatPanelTopRow}>
            <div style={{display:"flex"}}>
                <Avatar></Avatar>
                <div>
                  <div>Tin ghim</div>
                  <div>Ghim info</div>
                </div>
              </div>
            </div>
          </div>
          <div className={classes.chatPanelMid}></div>
          <div className={classes.chatPanelBot}>
            <div className={classes.chatBotRow} style={{borderBottom: "solid 1px gray"}}>
              <Image></Image>
              <AttachFile></AttachFile>
            </div>
            <div className={classes.chatBotRow} style={{display: "flex"}}>

              <Input sx={{flexGrow:1}}></Input>
              
              <ThumbUp></ThumbUp>
              <Send></Send>
            </div>
          </div>
        </div>
      </div>
    );
}